<template>
    <static-foundation-page-content class="newsletter-unsubscription-success">
        <p>{{$tc('newsletter.pages.unsubscription.text')}}</p>
    </static-foundation-page-content>
</template>
<script>
import StaticFoundationPageContent from '@/components/foundation/StaticFoundationPageContent';

export default {
    name: 'NewsletterUnsubscriptionSuccess',
    components: {
        StaticFoundationPageContent
    },
    activated() {
        this.$store.commit('navigation/setPageRoot', {
            title: this.$tc('newsletter.pages.unsubscription.heading'),
            path: null
        });
    },
}
</script>
